import { WEB_TEXT_UPDATE_USER_INFO } from "./pageString";

export const CAMPAIGNID = process.env.REACT_APP_CAMPAIGNID;
export const SAAS_CAMPAIGNID = process.env.REACT_APP_SAAS_CAMPAIGNID;
export const TENANTID = process.env.REACT_APP_TENANTID;
export const BUSINESS_ACCOUNT_ID = process.env.REACT_APP_BUSINESS_ACCOUNT_ID;

export const START_DATE = process.env.REACT_APP_START_DATE_CAMPAIGN;
export const START_DATE_TIME = process.env.REACT_APP_START_DATE_TIME_CAMPAIGN;

export const END_DATE = process.env.REACT_APP_END_DATE_CAMPAIGN;
export const END_DATE_TIME = process.env.REACT_APP_END_DATE_TIME_CAMPAIGN;

export const LINK_VIDEO = process.env.REACT_APP_LINK_VIDEO;

export const STATIC_PATH = process.env.REACT_APP_STATIC_PATH;

export const IS_LOAD_ASSETS_FROM_URL =
  process.env.REACT_APP_IS_LOAD_ASSETS_FROM_URL;
export const HOTLINE = "Hotline <strong>1900 633 415</strong>";
export const TELCO = [
  {
    label: "Viettel",
    value: "Viettel",
  },
  {
    label: "Vinaphone",
    value: "Vinaphone",
  },
  {
    label: "Mobiphone",
    value: "Mobiphone",
  },

  {
    label: "Vietnamobile",
    value: "Vietnamobile",
  },
];

export const GENDER_OPTIONS = [
  { value: "male", label: WEB_TEXT_UPDATE_USER_INFO.MALE },
  { value: "female", label: WEB_TEXT_UPDATE_USER_INFO.FE_MALE },
  { value: "other", label: WEB_TEXT_UPDATE_USER_INFO.OTHER },
];
